const context = require.context("./", false, /\.js$/);

const allFunctions = {};
context.keys().forEach((key) => {
    if (key !== "./index.js") {
        Object.assign(allFunctions, context(key));
    }
});
export default allFunctions;
